import {Component, OnDestroy, OnInit} from '@angular/core';
import {GenericDatatableComponent} from '../../../shared/components/generic-datatable/generic-datatable.component';
import {select} from '@ngrx/store';
import * as fromSites from '../../reducers';
import {
  LoadPublicationsAction,
  OrderPublicationsByAction,
  QuickSearchPublicationsAction,
  SearchPublicationsAction,
  ToggleSearchPublicationsAction,
  ChangePublicationsPageSizeAction,
  PagePublicationsToAction, ClearPublicationsAction
} from '../../actions/publications-list';
import {PublicationFilter} from '../../models/publication-filter';
import * as fromRoot from '../../../shared/reducers';
import {SetPreferencesAction} from '../../../shared/actions/preferences';

@Component({
  selector: 'storever-publication-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class PublicationListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    super.ngOnInit();
    this.loadDataOnChangeUrl('packageID descending', 'publications_row_size');
    // this.orderByChanged('packageID descending');

  }

  ngOnDestroy(): void {
    this.storeRoot.dispatch(new ClearPublicationsAction());
    this.dataConfig.form.markAsPristine();
    this.router.navigate( [], { queryParams: {}});
  }

  loadData(): void {
   // this.orderByChanged('packageID descending');
    this.storeRoot.dispatch(new LoadPublicationsAction());
  }

  storeSelect(): void {
    this.pageSize$ = this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, 'publications_row_size'));
    this.count$ = this.storeSite.pipe(select(fromSites.selectors.getPublicationsCount));
    this.showFilter$ = this.storeSite.pipe(select(fromSites.selectors.getPublicationsShowFilter));
    this.data$ = this.storeSite.pipe(select(fromSites.selectors.getPublications));
    let pageSizeInit = true ;
    this.sub$ = this.pageSize$.subscribe(pageSize => {
      if ( pageSizeInit && pageSize ) {
      this.storeSite.dispatch(new ChangePublicationsPageSizeAction(pageSize));
      pageSizeInit = false;
      }
    });
    this.subscriptions.push(this.sub$);
  }

  orderByChanged(orderBy: string): void {
    this.storeSite.dispatch(new OrderPublicationsByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    this.storeSite.dispatch(new SetPreferencesAction({ name: 'publications_row_size', value: '' + pageSize }));
    this.storeSite.dispatch(new ChangePublicationsPageSizeAction(pageSize));
  }

  pageChanged(page: number): void {
    this.storeShipping.dispatch(new PagePublicationsToAction(page));
  }


  applyFilter(filterForm: PublicationFilter): void {
    this.storeSite.dispatch(new SearchPublicationsAction(this.filterDeleteIfNilService.flatten(filterForm)));
  }

  applyQuickFilter(query: string): void {
    this.storeSite.dispatch(new QuickSearchPublicationsAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeSite.dispatch(new ToggleSearchPublicationsAction(!showFilter));
  }

  disablePagination(): boolean {
    return false;
  }

}
